export const SupportEmailReasons = {
    ORDER_MISSING: 'ORDER_MISSING',
    BILLING_NOT_PAID: 'BILLING_NOT_PAID',
    OTHER_GENERAL_QUESTION: 'OTHER_GENERAL_QUESTION',
    LOGIN_NOT_POSSIBLE: 'LOGIN_NOT_POSSIBLE',
    ELLA_NOT_STARTING: 'ELLA_NOT_STARTING',
    ERROR_MESSAGES: 'ERROR_MESSAGES',
    OTHER_TECHNICAL_QUESTION: 'OTHER_TECHNICAL_QUESTION',
};
